import * as React from 'react'
import GridItem from '../../../grid/GridItem'
import GridContainer from '../../../grid/GridContainer'
import CustomTabs from '../../../tab/CustomTabs'
import PeopleIcon from '@material-ui/icons/People'
import ProcessingExtensionTable from '../../../extension/ProcessingExtensionTable'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import CompletedExtensionTable from '../../../extension/CompletedExtensionTable'
import OpenExtensionTable from '../../../extension/OpenExtensionTable'

export default function AdminClaimsTab() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="primary"
          tabs={[
            {
              tabName: 'Offen',
              tabIcon: PeopleIcon,
              tabContent: <OpenExtensionTable/>,
            },
            {
              tabName: 'In Bearbeitung',
              tabIcon: PeopleIcon,
              tabContent: <ProcessingExtensionTable/>,
            },
            {
              tabName: 'Abgeschlossen',
              tabIcon: DoneAllIcon,
              tabContent: <CompletedExtensionTable/>,
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  )
}
